// Javascript strict mode
'use strict';
// Config, this is all defined parameter and constant
var Conf 	= require('../Config');
// Load axios module
var axios 	= require('axios');
// Load cookie module
var VueCookies = require('vue-cookies');
VueCookies.config('7d');
// import store file by using access token
import store from './../store/index'
const pako = require('pako');
// Com comunication cor server
export default {
	/*
	* This is comunication for service server
	* -How to work-
	* Method call Com.Service(MethidID int - is requierd parameter, second Object data {any object})
	* Server response array [StatusCode : 1 or 0 and maybe more status code such as 6,8 and more, Message: string, Data : [array]]
	*/
    Service : async function (MethodID, Object) {
    	// Validate MethidID
    	if (! MethodID) return false;

      var ServiceURL = Conf.Conf.ApiURL;
      // This is full accees on our api services
      // Send response to service server

      let url = parseInt(MethodID)?'?ApiID='+Conf.Conf.AppId:MethodID + '?API&ApiID='+Conf.Conf.AppId;

      return axios.post(ServiceURL + url, {
	    // return axios.post(Conf.Conf.ApiURL, {
			AccessToken : store.state.AccessToken,
			Function 	: MethodID,
			Request 	: Object,
			PROJECT		: Conf.Conf.ProjectID,
			SoftVersion : Conf.Conf.SoftVersion,
			Language 	: 'ka',
			SESSION 	: VueCookies.get('Session'),
            headers: {
                'Accept-Encoding': 'gzip'
            }
		}).then((response) => {
            const decompress = str => pako.inflateRaw(Buffer.from(str, 'base64'), {to: 'string'});
            response.data = JSON.parse(decompress(response.data));
	    	// Validate access token
	    	if (response.data.AccessToken == 'reject-access-token') VueCookies.remove('Session');
	    	// Update token
	    	store.commit('UpdateToken', response.data.AccessToken)
	    	// Return response data
	    	return response.data;
	    }).catch((error) => { console.log(error); });

	}, // [./ end] Service()
}



// WEBPACK FOOTER //
// ./src/libs/Com.js